











































































import { createComponent } from '@vue/composition-api';

export default createComponent({
  props: {
    value: { type: Boolean, required: true },
  },
  setup(_, context) {
    return {
      input(value: boolean) {
        context.emit('input', value);
      },
    };
  },
});
